<div class="order-req-page">

  <div class="page-header">
    <div class="page-header-text">
      <h2>{{ 'page.order_req_title' | translate }}</h2>
      <p>{{ 'page.order_req_subtitle' | translate }}</p>
    </div>
  </div>

  <div class="app-card order-req-card">
    <div class="table-wrap" *ngIf="!showMessage">
      <table class="req-table">
        <thead>
          <tr>
            <th>#</th>
            <th>{{ 'lbl.name' | translate }}</th>
            <th>{{ 'lbl.image' | translate }}</th>
            <th>{{ 'lbl.date' | translate }}</th>
            <th>{{ 'lbl.email' | translate }}</th>
            <th>{{ 'lbl.link' | translate }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of orders_arr">
            <td class="cell-id">{{ item.id }}</td>
            <td class="cell-name">{{ item.name }}</td>
            <td>
              <img class="order-req-img" [src]="item.image[0]" alt="Product" />
            </td>
            <td class="cell-date">{{ item.requested_date | date : "d MMM y" }}</td>
            <td class="cell-email">
              <span *ngIf="!item.client">test&#64;test</span>
              <span *ngIf="item.client">{{ item.client.email }}</span>
            </td>
            <td>
              <a class="order-req-link" target="_blank" href="{{ item.URL }}">
                <span class="material-symbols-outlined">open_in_new</span>
                {{ 'btn.view' | translate }}
              </a>
            </td>
            <td>
              <button class="icon-btn icon-btn--danger" [title]="'btn.delete' | translate">
                <span class="material-symbols-outlined">delete</span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="empty-state" *ngIf="showMessage">
      <div class="empty-state-icon">
        <span class="material-symbols-outlined">inbox</span>
      </div>
      <h3>{{ 'empty.order_requests' | translate }}</h3>
      <p>{{ 'empty.order_requests_sub' | translate }}</p>
    </div>
  </div>

</div>
